<template>
  <footer class="login-footer">
    <div class='container'>
      <div class="browse">
        <span class="icp">网站总浏览: 68351</span>
        <span>网站今日访问量: 72</span>
      </div>
      <div class="copyright">Copyright 2023.版权所有：昌都市自然资源资源局</div>
      <div class='img'>
        <img class="footer-img-logo" src="@/assets/images/footer/logo.png" alt="">
        <p> 藏公网安备00000000000000号 </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LoginFooter'
}
</script>

<style scoped lang='less'>
.login-footer {
  padding: 1.688rem 0 1.313rem 0;
  width: 100%;
  background: #EAF3FB;

  .container {
    text-align: center;
    color: #999;

    .browse {
      margin-top: .625rem;

      span:last-child {
        margin-left: 2rem;
      }
    }

    .copyright {
      margin-top: .625rem;
    }

    .img {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: .625rem;

      .footer-img-logo {
        width: 1.125rem;
        height: 1.25rem;
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
